import { render, staticRenderFns } from "./dynamicState.vue?vue&type=template&id=48b5bb61&scoped=true&"
import script from "./dynamicState.vue?vue&type=script&lang=ts&"
export * from "./dynamicState.vue?vue&type=script&lang=ts&"
import style0 from "./dynamicState.vue?vue&type=style&index=0&id=48b5bb61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b5bb61",
  null
  
)

export default component.exports